import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";

export const VideoUploadIcon = VideoLibraryIcon;
export { VideoUploadEdit } from "./edit";
export { VideoUploadList } from "./list";
